import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./DeviceItem.style";
import * as P from "../../../../../../../utils/pipes";

// Hooks

import { useQuery } from "@apollo/client";

import { QUERY_GET_ALL_DEVICES } from "../../../../../../../graphql/queries/Devices";

function DeviceItem({
  device,
  added
}) {

  const { t, i18n: { language } } = useTranslation("global");

  const { 
    data: allDevicesData,
    loading: allDevicesDataLoading,
    error: allDevicesDataError,
  } = useQuery(
    QUERY_GET_ALL_DEVICES
  );

  const getDeviceName = (deviceType) => {
    if (!device) return "";
    switch (deviceType) {
      case "blood_pressure":
        return t("profile.smartDevices.bloodPressure");
      case "pulse_ox":
        return t("profile.smartDevices.pulseOx");
      default:
        return "Device";
    }
  }
  


  return (
    <S.DeviceItem
      active={added}
    >
      <i className={`device-addition-icon icon ${added ? "zaia-i-remove" : "zaia-i-add-1"}`}></i>
      <div className="device-info">
        <div className="device-info__name">
          {getDeviceName(device?.metadata.device_type)}
        </div>
        <div className="device-info__type">
          {device?.metadata.device_model} - {device?.id}
        </div>
      </div>
    </S.DeviceItem>
  );
}




export default DeviceItem;
